import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StudioPageShell from '../../components/studio/StudioPageShell';
import AiAssistantsPanel from '../../components/studio/AiAssistantsPanel';

export default function StudioConnectPage() {
  return (
    <StudioPageShell
      title="AI assistants"
      subtitle="Let Cursor, Claude Code and other MCP clients run your published flows"
      backTo="/studio"
      maxWidth={960}
      actions={(
        <Button
          component={RouterLink}
          to="/studio/help/mcp"
          size="small"
          startIcon={<HelpOutlineIcon />}
          sx={{ textTransform: 'none' }}
        >
          Help
        </Button>
      )}
    >
      <AiAssistantsPanel />
    </StudioPageShell>
  );
}
